<template>
  <div
    class="booking-cta"
    :class="{
      'booking-cta--centered': centered,
      'booking-cta--inline': inline
    }"
  >
    <button
      v-if="showAvailability"
      type="button"
      class="booking-cta__secondary"
      @click="$emit('availability')"
    >
      Verfügbarkeit
    </button>
    <button
      type="button"
      class="booking-cta__primary"
      @click="openBookingModal()"
    >
      Jetzt reservieren
    </button>
  </div>
</template>

<script>
import { useBookingModal } from '../../composables/useBookingModal.js'

export default {
  emits: ['availability'],
  props: {
    showAvailability: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { openBookingModal } = useBookingModal()
    return { openBookingModal }
  }
}
</script>

<style scoped lang="scss">
.booking-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;

  &--centered {
    justify-content: center;
  }

  &--inline {
    display: inline-flex;
    flex-wrap: nowrap;
  }

  &__secondary,
  &__primary {
    display: inline-block;
    padding: 0.75rem 2.875rem;
    font-weight: bold;
    border: 2px solid transparent;
    border-radius: 4px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  }

  &__secondary {
    background: #42d9e4;
    color: #fff;
    border-color: #42d9e4;

    &:hover,
    &:focus {
      background: #2fcddf;
      border-color: #2fcddf;
      color: #fff;
    }
  }

  &__primary {
    background: #f2c900;
    color: #515a5f;
    border-color: #f2c900;
    box-shadow: 0 4px 14px rgba(242, 201, 0, 0.35);

    &:hover,
    &:focus {
      background: #e0b800;
      border-color: #e0b800;
      color: #515a5f;
      box-shadow: 0 6px 18px rgba(242, 201, 0, 0.45);
    }
  }
}

@media (max-width: 767px) {
  .booking-cta:not(.booking-cta--inline) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    .booking-cta__secondary,
    .booking-cta__primary {
      width: 100%;
      text-align: center;
      padding: 0.875rem 1.5rem;
      font-size: 1rem;
    }

    .booking-cta__primary {
      order: 2;
      font-size: 1.0625rem;
      letter-spacing: 0.02em;
    }

    .booking-cta__secondary {
      order: 1;
    }
  }
}
</style>
